<template src="./app.html"/>

<script>
import computedProperties from './app/computed-properties';
import watchProperties from './app/watch-properties';
import dataProperties from './app/data-properties';
import methodsProperties from './app/methods-properties';

export default {
  name: 'App',
  components: {},
  computed: {...computedProperties},
  watch: {...watchProperties},
  data () {return {...dataProperties}},
  methods: {...methodsProperties},
  mounted () {
    this.loadMockData()
    localStorage.setItem('appId', this.appName)
    setTimeout(() => {
      this.ready = true
      this.checkLogin()
    }, 100)
  }
}
</script>

<style lang="css" src="./app.css"/>